// extracted by mini-css-extract-plugin
export default {"container":"Login_container__Qu3UC","card":"Login_card__+UZIA","form-control":"Login_form-control__V08Rq","divider":"Login_divider__yAcdp","dividerLabel":"Login_dividerLabel__KS9BF"};